// ─────────────────────────────────────────────────────────────────────────────
// context-links — registry mapping each MessageContextPane block to the config
// screen where it's authored, so the rep can jump from "what the message used"
// to "where this is configured" (contact_modal.md §3). Per-instance: a block
// resolves to null when the client has no dedicated config screen yet, in which
// case the pane renders the block WITHOUT a deep-link (graceful).
//
// CARR today has no standalone Messaging-Framework / Personas / Account-Scoring
// routes (the SSO matrix lives in the DB + docs, personas/scoring surface inside
// account/contact views). All map to null until those screens exist; add the
// route here to light up the link app-wide.
// ─────────────────────────────────────────────────────────────────────────────

export type ContextBlock =
  | "messaging_framework"
  | "personas"
  | "account_scoring"
  | "positioning";

const CONTEXT_LINKS: Record<ContextBlock, string | null> = {
  messaging_framework: null,
  personas: null,
  account_scoring: null,
  positioning: null,
};

/** Route for a context block's config screen, or null if none exists yet. */
export function contextLink(block: ContextBlock): string | null {
  return CONTEXT_LINKS[block] ?? null;
}
